"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bankingDaysBetween = void 0;
const calendarDaysBetween_1 = require("../calendarDaysBetween");
const isBankingDay_1 = require("../isBankingDay");
const parseInputDate_1 = require("../../utils/parseInputDate");
const toIsoDate_1 = require("../../utils/toIsoDate");
function bankingDaysBetween(startDate, endDate) {
    const startDateIso = (0, toIsoDate_1.toIsoDate)(startDate);
    const endDateIso = (0, toIsoDate_1.toIsoDate)(endDate);
    if (startDateIso === endDateIso) {
        return 0;
    }
    const startDateTime = (0, parseInputDate_1.parseInputDate)(startDate);
    const endDateTime = (0, parseInputDate_1.parseInputDate)(endDate);
    let latestDate;
    let totalDifference = (0, calendarDaysBetween_1.calendarDaysBetween)(startDateIso, endDateIso);
    let isNegative;
    if (startDateIso > endDateIso) {
        latestDate = startDateTime;
        isNegative = true;
    }
    else {
        latestDate = endDateTime;
        isNegative = false;
    }
    let bankDaysDifference = 0;
    while (totalDifference != 0) {
        if ((0, isBankingDay_1.isBankingDay)(latestDate.toISODate())) {
            isNegative ? bankDaysDifference-- : bankDaysDifference++;
        }
        latestDate = latestDate.minus({ days: 1 });
        isNegative ? totalDifference++ : totalDifference--;
    }
    return bankDaysDifference;
}
exports.bankingDaysBetween = bankingDaysBetween;
//# sourceMappingURL=index.js.map